"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var kebabCase = require('kebab-case');

var allProps = require('./keys.json');

var jamSession = require('@mapbox/expression-jamsession');

function isPaintProp(prop) {
  return allProps.paints.indexOf(prop) >= 0;
}

function isLayoutProp(prop) {
  return allProps.layouts.indexOf(prop) >= 0;
}

function whichProp(prop) {
  if (allProps.paints.indexOf(prop) >= 0) {
    return 'paint';
  }

  if (allProps.layouts.indexOf(prop) >= 0) {
    return 'layout';
  }

  return 'other';
}

function utils() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (args[0] && Array.isArray(args[0]) && args[0].raw) {
    // We're being used as a tagged template
    return jamSession.formulaToExpression(args[0].raw[0]);
  } else throw 'Mapbox-gl-utils unexpectedly called as a function. Use .init(map)';
}

function parseSource(source) {
  if (String(source).match(/\.(geo)?json/) || source.type === 'Feature' || source.type === 'FeatureCollection') {
    return {
      type: 'geojson',
      data: source
    };
  } else if (String(source).match(/^mapbox:\/\//)) {
    return {
      type: 'vector',
      url: source
    };
  } else {
    return source;
  }
} // Magically turn a function that works on one layer into one that works on array of layers.


var arrayify = function arrayify(f) {
  return function (things) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return Array.isArray(things) ? things.forEach(function (t) {
      return f.apply(void 0, [t].concat(args));
    }) : f.apply(void 0, [things].concat(args));
  };
};

function upperCamelCase(s) {
  return s[0].toUpperCase() + kebabCase.reverse(s).slice(1);
}

utils.init = function (map, mapboxgl) {
  var _this = this;

  var U = this;
  this.mapboxgl = mapboxgl;
  var layerTypes = ['line', 'fill', 'circle', 'symbol', 'video', 'raster', 'fill-extrusion', 'heatmap', 'hillshade'];

  function makeSetProp(prop, setPropFunc) {
    var funcName = 'set' + upperCamelCase(prop);
    U[funcName] = arrayify(function (layer, value) {
      return map[setPropFunc](layer, prop, value);
    });
  }

  ;

  function makeAddLayer(layerType, obj, fixedSource) {
    var funcName = 'add' + upperCamelCase(layerType);

    if (fixedSource) {
      obj[funcName] = function (id, options, before) {
        return U.addLayer(id, fixedSource, layerType, options, before);
      };
    } else {
      obj[funcName] = function (id, source, options, before) {
        return U.addLayer(id, source, layerType, options, before);
      };
    }
  }

  function makeSource(id) {
    // returns an object on which we can call .addLine() etc.
    var out = {};
    layerTypes.forEach(function (type) {
      return makeAddLayer(type, out, id);
    });
    return out;
  }

  function addSource(id, props) {
    map.addSource(id, props);
    return makeSource(id);
  }

  function makeAddSource(sourceType) {
    var funcName = 'add' + upperCamelCase(sourceType);

    U[funcName] = function (id, props) {
      addSource(id, _objectSpread({
        type: sourceType
      }, props));
    };
  }

  function layersBySource(source) {
    return map.getStyle().layers.filter(function (l) {
      return l.source === source;
    }).map(function (l) {
      return l.id;
    });
  }

  Object.assign(this, {
    _loaded: false,
    hoverPointer: arrayify(function (layer) {
      map.on('mouseenter', layer, function (e) {
        return map.getCanvas().style.cursor = 'pointer';
      });
      map.on('mouseleave', layer, function (e) {
        return map.getCanvas().style.cursor = '';
      });
    }),
    hoverFeatureState: arrayify(function (layer, source, sourceLayer, enterCb, leaveCb) {
      if (Array.isArray(source)) {
        // assume we have array of [source, sourceLayer]
        source.forEach(function (_ref) {
          var _ref2 = _slicedToArray(_ref, 2),
              source = _ref2[0],
              sourceLayer = _ref2[1];

          return _this.hoverFeatureState(layer, source, sourceLayer);
        });
        return;
      }

      if (source === undefined) {
        var l = _this.getLayerStyle(layer);

        source = l.source;
        sourceLayer = l['source-layer'];
      }

      var featureId;

      function setHoverState(state) {
        if (featureId) {
          map.setFeatureState({
            source: source,
            sourceLayer: sourceLayer,
            id: featureId
          }, {
            hover: state
          });
        }
      }

      map.on('mousemove', layer, function (e) {
        var f = e.features[0];

        if (f && f.id === featureId) {
          return;
        }

        setHoverState(false);
        if (!f) return;

        if (featureId && leaveCb) {
          leaveCb(_objectSpread({}, e, {
            oldFeatureId: featureId
          }));
        }

        featureId = f.id;
        setHoverState(true);

        if (enterCb) {
          enterCb(e);
        }
      });
      map.on('mouseleave', layer, function (e) {
        setHoverState(false);
        e.oldFeatureId = featureId;
        featureId = undefined;

        if (leaveCb) {
          leaveCb(e);
        }
      });
    }),
    hoverPopup: function hoverPopup(layers, cb) {
      var popupOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var popup = new this.mapboxgl.Popup(_objectSpread({
        closeButton: false
      }, popupOptions));
      return arrayify(function (layer, cb) {
        map.on('mouseenter', layer, function (e) {
          if (e.features[0]) {
            popup.setLngLat(e.lngLat);
            popup.setHTML(cb(e.features[0], popup));
            popup.addTo(map);
          }
        });
        map.on('mouseout', layer, function (e) {
          popup.remove();
        });
      })(layers, cb);
    },
    clickPopup: function clickPopup(layers, cb) {
      var popupOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var popup = new this.mapboxgl.Popup(_objectSpread({}, popupOptions));
      return arrayify(function (layer, cb) {
        map.on('click', layer, function (e) {
          if (e.features[0]) {
            popup.setLngLat(e.features[0].geometry.coordinates.slice());
            popup.setHTML(cb(e.features[0], popup));
            popup.addTo(map);
          }
        });
      })(layers, cb);
    },
    clickLayer: arrayify(function (layer, cb) {
      map.on('click', layer, function (e) {
        e.features = map.queryRenderedFeatures(e.point, {
          layers: [layer]
        });
        cb(e);
      });
    }),
    clickOneLayer: function clickOneLayer(layers, cb) {
      map.on('click', function (e) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = layers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var layer = _step.value;
            var features = map.queryRenderedFeatures(e.point, {
              layers: [layer]
            });

            if (features[0]) {
              cb({
                layer: layer,
                feature: features[0],
                features: features
              });
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator["return"] != null) {
              _iterator["return"]();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      });
    },
    mapAddLayerBefore: function mapAddLayerBefore(layer, before) {
      if (before) {
        map.addLayer(layer, before);
      } else {
        map.addLayer(layer);
      }
    },
    addLayer: function addLayer(id, source, type, props, before) {
      this.mapAddLayerBefore(this.layerStyle(id, source, type, props), before);
      return makeSource(source);
    },
    add: function add(id, source, type, props, before) {
      this.mapAddLayerBefore(_objectSpread({
        id: id,
        source: parseSource(source),
        type: type
      }, this.properties(props)), before);
      return makeSource(source); // Could get very weird if source is not a string...
    },
    removeLayer: arrayify(function (layer) {
      var swallowError = function swallowError(data) {
        if (!data.error.message.match(/does not exist/)) {
          console.error(data.error);
        }
      };

      map.once('error', swallowError);
      map.removeLayer(layer);
      map.off('error', swallowError);
    }),
    addGeoJSON: function addGeoJSON(id) {
      var geojson = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        type: 'FeatureCollection',
        features: []
      };
      var props = arguments.length > 2 ? arguments[2] : undefined;
      return addSource(id, _objectSpread({
        type: 'geojson',
        data: geojson
      }, props));
    },
    addVector: function addVector(id, props) {
      if (typeof props === 'string') {
        if (props.match(/\{z\}/)) {
          return addSource(id, {
            type: 'vector',
            tiles: [props]
          });
        } else {
          // mapbox://, http://.../index.json
          return addSource(id, {
            type: 'vector',
            url: props
          });
        }
      } else {
        return addSource(id, _objectSpread({
          type: 'vector'
        }, this.properties(props)));
      }
    },
    setProperty: arrayify(function (layer, prop, value) {
      if (_typeof(prop) === 'object') {
        Object.keys(prop).forEach(function (k) {
          return _this.setProperty(layer, k, prop[k]);
        });
      } else {
        var kprop = kebabCase(prop);

        if (isPaintProp(kprop)) {
          map.setPaintProperty(layer, kprop, value);
        } else if (isLayoutProp(kprop)) {
          map.setLayoutProperty(layer, kprop, value);
        } else {// ignore properties such as minzoom, type, filter, etc for now.
        }
      }
    }),
    properties: function properties(props) {
      if (!props) {
        return undefined;
      }

      var out = {},
          which = {
        paint: {},
        layout: {},
        other: {}
      };
      Object.keys(props).forEach(function (prop) {
        var kprop = kebabCase(prop);
        which[whichProp(kprop)][kprop] = props[prop];
      });

      if (Object.keys(which.paint).length) {
        out.paint = which.paint;
      }

      if (Object.keys(which.layout).length) {
        out.layout = which.layout;
      }

      Object.assign(out, which.other);
      return out;
    },
    layerStyle: function layerStyle() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      // layerStyle([id,] [source,] [type,] props)
      var id = args[0],
          source = args[1],
          type = args[2];
      var props = args.find(function (arg) {
        return _typeof(arg) === 'object' && !Array.isArray(arg);
      });
      var ret = this.properties(props) || {};
      if (typeof id === 'string') ret.id = id;
      if (typeof source === 'string') ret.source = source;
      if (typeof type === 'string') ret.type = type;
      return ret;
    },
    getLayerStyle: function getLayerStyle(layer) {
      return map.getStyle().layers.find(function (l) {
        return l.id === layer;
      });
    },
    setLayerStyle: arrayify(function (layer, style) {
      var clearProps = function clearProps() {
        var oldObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var newObj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return Object.keys(oldObj).forEach(function (key) {
          if (!(key in newObj)) {
            _this.setProperty(layer, key, undefined);
          }
        });
      };

      if (!style) {
        style = layer;
        layer = style.id;
      }

      var oldStyle = _this.getLayerStyle(layer);

      var newStyle = _this.properties(style);

      clearProps(oldStyle.paint, newStyle.paint);
      clearProps(oldStyle.layout, newStyle.layout); // Hmm, this gets murky, what exactly is meant to happen with non-paint, non-layout props?

      _this.setProperty(layer, _objectSpread({}, newStyle.paint, {}, newStyle.layout));
    }),
    setData: function setData(source, data) {
      map.getSource(source).setData(data);
    },
    show: arrayify(function (layer) {
      return _this.setVisibility(layer, 'visible');
    }),
    hide: arrayify(function (layer) {
      return _this.setVisibility(layer, 'none');
    }),
    toggle: arrayify(function (layer, state) {
      return _this.setVisibility(layer, state ? 'visible' : 'none');
    }),
    showSource: arrayify(function (source) {
      return _this.setVisibility(layersBySource(source), 'visible');
    }),
    hideSource: arrayify(function (source) {
      return _this.setVisibility(layersBySource(source), 'none');
    }),
    toggleSource: arrayify(function (source, state) {
      return _this.setVisibility(layersBySource(source), state ? 'visible' : 'none');
    }),
    setFilter: arrayify(function (layer, filter) {
      return map.setFilter(layer, filter);
    }),
    removeSource: arrayify(function (source) {
      // remove layers that use this source first
      var layers = layersBySource(source);

      _this.removeLayer(layers);

      if (map.getSource(source)) {
        map.removeSource(source);
      }
    }),
    setLayerSource: arrayify(function (layerId, source, sourceLayer) {
      var oldLayers = map.getStyle().layers;
      var layerIndex = oldLayers.findIndex(function (l) {
        return l.id === layerId;
      });
      var layerDef = oldLayers[layerIndex];
      var before = oldLayers[layerIndex + 1] && oldLayers[layerIndex + 1].id;
      layerDef.source = source;

      if (sourceLayer) {
        layerDef['source-layer'] = sourceLayer;
      } else if (sourceLayer !== undefined) {
        delete layerDef['source-layer'];
      }

      map.removeLayer(layerId);

      _this.mapAddLayerBefore(layerDef, before);
    }),
    onLoad: function onLoad(cb) {
      var _this2 = this;

      if (map.loaded() || this._loaded) {
        cb();
      } else {
        map.once('load', function () {
          _this2._loaded = true;
          cb();
        });
      }
    },
    setRootProperty: function setRootProperty(propName, val) {
      var style = map.getStyle();
      style[kebabCase(propName)] = val;
      map.setStyle(style);
    },
    setTransition: function setTransition(val) {
      this.setRootProperty('transition', val);
    },
    loadImage: function loadImage(id, url) {
      if (typeof url === 'string' && url.match(/\.[a-z]+$/)) {
        map.loadImage(url, function (error, image) {
          if (error) {
            console.error("Error loading image ".concat(url), error);
          } else {
            map.addImage(id, image);
          }
        });
      } else {
        return map.addImage(id, url);
      }
    },
    lockOrientation: function lockOrientation() {
      map.touchZoomRotate.disableRotation();
      map.dragRotate.disable();
    }
  });
  this.update = this.setData; // deprecated
  // Turn every property into a 'setTextSize()', 'setLineColor()' etc.

  allProps.paints.forEach(function (prop) {
    return makeSetProp(prop, 'setPaintProperty');
  });
  allProps.layouts.forEach(function (prop) {
    return makeSetProp(prop, 'setLayoutProperty');
  });
  layerTypes.forEach(function (layerType) {
    return makeAddLayer(layerType, U);
  });
  ['raster', 'raster-dem', 'image', 'video'] // vector, geojson taken care of
  .forEach(function (sourceType) {
    return makeAddSource(sourceType);
  });
  map.U = this;
  return this;
}; // Hmm. Using ES2015 export seems to play nicer with Webpack. But then testing within Node doesn't work. Sigh.


module.exports = utils; // export default utils;